export default "/dist/fonts/Exo2-Bold.ttf";